import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Notification } from '../models/notification';
import { NotificationPreference } from '../models/notification-preference';
import { environment } from '../../environments/environment';

@Injectable()
export class NotificationService {

  baseUrl = environment.notificationServiceBaseUrl;

  constructor(private http: HttpClient) { }

  findNotificationNotUserAcknowledged() {
    const url = `${this.baseUrl}notifications/list`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.get<Notification[]>(url, { headers });
  }

  updateNotificationById(id: string)  {
    const url = `${this.baseUrl}notifications/${id}/acknowledged`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.put<void>(url, { headers });
  }

  getUserPreferences(userId: string) {
    const url = `${this.baseUrl}preferences/${userId}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.get<NotificationPreference[]>(url, { headers });
  }

  save(userId: string, notificationPreference: NotificationPreference) {
    const url = `${this.baseUrl}preferences/${userId}`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.put<void>(url, notificationPreference, { headers });
  }


  getCustomUserPreferences(userId: string) {
    const url = `${this.baseUrl}preferences/${userId}/getCustomUserPreference`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.get<any[]>(url, { headers });
  }

  saveCustomPreference(userId: string, customPreferenceObject: any) {
    const url = `${this.baseUrl}preferences/updateCustomPreferences/`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.put<any>(url, customPreferenceObject, { headers });
  }

  updateNotificationByDate(date: string)  {
    const url = `${this.baseUrl}notifications/${date}/updateNotificationByDate`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.put<Notification[]>(url, { headers });
  }

  getCountOfUnacknowledgedWebNotification(){
    const url = `${this.baseUrl}notifications/web/count`;
    const headers = new HttpHeaders()
      .set('Accept', 'application/json');
    return this.http.get<any[]>(url, { headers });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/services/notification.service.ts